import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { Settings } from './types';

const settingsSlice = (state: RootState) => state.settings;

export const selectSettings = createSelector([settingsSlice], (state): Settings => state);
